import { render, staticRenderFns } from "./user-projects-list.vue?vue&type=template&id=1f1e2c82&"
import script from "./user-projects-list.vue?vue&type=script&lang=js&"
export * from "./user-projects-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports